<div class="loginform">

  <!-- STEP 1: Email Entry -->
  <form *ngIf="step === 1" [formGroup]="emailForm" (ngSubmit)="onSubmitEmail()">
    <div class="signin">Forgot Password</div>

    <div class="lblmsg" *ngIf="msg">
      <label class="logininfo">{{ msg }}</label>
    </div>

    <div class="form-floating mb-3 mt-3">
      <input formControlName="email"
             class="form-control custominput"
             id="id_email"
             type="text"
             placeholder="Email" />
      <label for="id_email" class="lblfocus">Email</label>
      <div *ngIf="submitted && f['email'].errors" class="text-danger">
        <div class="errorStyle" *ngIf="f['email'].errors['required']">Email is required</div>
        <div class="errorStyle" *ngIf="f['email'].errors['pattern']">Email must be a valid email address.</div>
      </div>
    </div>

    <div class="btnlogin">
      <button type="button" (click)="cancelml()" class="btn btn-secondary btnlogincancel btncomman">Cancel</button>
      <button type="submit" class="btn btn-primary btnloginsubmit btncomman" [disabled]="isLoading">
        <span *ngIf="!isLoading">Submit</span>
        <span *ngIf="isLoading">Sending...</span>
      </button>
    </div>
  </form>

  <!-- STEP 2: 6-Digit OTP -->
  <div *ngIf="step === 2">
    <div class="otp-success-label">OTP sent to your email</div>
    <div class="signin">Verify OTP</div>

    <div class="lblmsg" *ngIf="msg">
      <label class="logininfo">{{ msg }}</label>
    </div>

    <p class="otp-subtext">Enter 6-digit OTP</p>

    <div class="otp-boxes">
      <input *ngFor="let box of otpBoxes; let i = index"
             #otpInput
             class="otp-box"
             type="text"
             inputmode="numeric"
             maxlength="1"
             [value]="otpDigits[i]"
             (input)="onOtpInput($event, i)"
             (keydown)="onOtpKeydown($event, i)"
             (paste)="onOtpPaste($event, i)" />
    </div>

    <div class="resend-row">
      <span *ngIf="resendCountdown > 0" class="resend-timer">Resend OTP in {{ resendCountdown }}s</span>
      <a *ngIf="resendCountdown === 0" href="javascript:void(0)" class="resend-link" (click)="resendOtp()">Resend OTP</a>
    </div>

    <div class="btnlogin">
      <button type="button" (click)="cancelml()" class="btn btn-secondary btnlogincancel btncomman">Cancel</button>
      <button type="button" class="btn btn-primary btnloginsubmit btncomman" [disabled]="isLoading" (click)="onVerifyOtp()">
        <span *ngIf="!isLoading">Next</span>
        <span *ngIf="isLoading">Verifying...</span>
      </button>
    </div>
  </div>

  <!-- STEP 3: New Password + Confirm Password -->
  <form *ngIf="step === 3" [formGroup]="pwdForm" (ngSubmit)="onSubmitPassword()">
    <div class="signin">Reset Password</div>

    <div class="lblmsg" *ngIf="msg">
      <label class="logininfo">{{ msg }}</label>
    </div>

    <!-- New Password -->
    <div class="form-floating mb-3 mt-3" style="position: relative;">
      <input formControlName="new_password"
             class="form-control custominput"
             id="id_new_password"
             [type]="showNewPassword ? 'text' : 'password'"
             placeholder="New Password" />
      <label for="id_new_password" class="lblfocus">New Password</label>
      <img [src]="showNewPassword ? '/assets/eye_open.svg' : '/assets/eye_close.svg'"
           class="viewpass"
           (click)="showNewPassword = !showNewPassword"
           alt="Toggle">
      <div *ngIf="pwdSubmitted && p['new_password'].errors" class="text-danger">
        <div class="errorStyle" *ngIf="p['new_password'].errors['required']">New password is required</div>
        <div class="errorStyle" *ngIf="p['new_password'].errors['minlength']">Password must be at least 8 characters</div>
      </div>
    </div>

    <!-- Confirm Password -->
    <div class="form-floating mb-3 mt-3" style="position: relative;">
      <input formControlName="confirm_password"
             class="form-control custominput"
             id="id_confirm_password"
             [type]="showConfirmPassword ? 'text' : 'password'"
             placeholder="Confirm Password" />
      <label for="id_confirm_password" class="lblfocus">Confirm Password</label>
      <img [src]="showConfirmPassword ? '/assets/eye_open.svg' : '/assets/eye_close.svg'"
           class="viewpass"
           (click)="showConfirmPassword = !showConfirmPassword"
           alt="Toggle">
      <div *ngIf="pwdSubmitted && p['confirm_password'].errors" class="text-danger">
        <div class="errorStyle" *ngIf="p['confirm_password'].errors['required']">Please confirm your password</div>
      </div>
      <div *ngIf="pwdSubmitted && pwdForm.errors?.['passwordMismatch']" class="text-danger">
        <div class="errorStyle">Passwords do not match</div>
      </div>
    </div>

    <div class="btnlogin">
      <button type="button" (click)="backToOtp()" class="btn btn-secondary btnlogincancel btncomman">Back</button>
      <button type="submit" class="btn btn-primary btnloginsubmit btncomman" [disabled]="isLoading">
        <span *ngIf="!isLoading">Reset</span>
        <span *ngIf="isLoading">Resetting...</span>
      </button>
    </div>
  </form>

</div>